"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollapsibleContainer = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const md_1 = require("react-icons/md");
const Typography_1 = require("../Typography/Typography");
const classnames_1 = __importDefault(require("classnames"));
/** Container to recieve content to display, that can be collapsed
 * DEFAULTS
 * The sheet is OPEN by default
 */
function CollapsibleContainer({ heading, children, startOpen = true, className = '' }) {
    const [isOpen, setOpen] = (0, react_1.useState)(startOpen);
    // baseSyntheticEvent is generic
    const onToggle = (event) => {
        event.preventDefault();
        setOpen((prevState) => !prevState);
    };
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: (0, classnames_1.default)('h-fit', className) }, { children: [(0, jsx_runtime_1.jsxs)("summary", Object.assign({ className: "select-none relative cursor-pointer flex px-4 hover:text-blue-90", onClick: onToggle }, { children: [(0, jsx_runtime_1.jsx)(Typography_1.Typography, Object.assign({ variant: "h300", as: "h4", className: "mb-4 pr-2 col-span-2 inline" }, { children: heading })), (0, jsx_runtime_1.jsx)(md_1.MdKeyboardArrowDown, { className: isOpen ? 'rotate-180' : '', size: 24 })] })), isOpen ? children : null] })));
}
exports.CollapsibleContainer = CollapsibleContainer;
//# sourceMappingURL=CollapsibleContainer.js.map